function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m121.5 64a57.5 57.5 0 1 1 -57.5-57.5 57.742 57.742 0 0 1 57.5 57.5z",
  fill: "#e8e8e8"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "#cdcdcd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m13.511 55.577a1.709 1.709 0 0 1 -.347-.035 1.75 1.75 0 0 1 -1.371-2.061 53.393 53.393 0 0 1 9.562-21.338 1.75 1.75 0 0 1 2.8 2.1 49.864 49.864 0 0 0 -8.932 19.932 1.752 1.752 0 0 1 -1.712 1.402z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30.263 26.87a1.75 1.75 0 0 1 -1.149-3.07 53.646 53.646 0 0 1 5.594-4.25 1.75 1.75 0 0 1 1.929 2.92 50.215 50.215 0 0 0 -5.227 3.972 1.742 1.742 0 0 1 -1.147.428z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48.497,
  cy: 49.271,
  r: 8.846
}), /*#__PURE__*/React.createElement("path", {
  d: "m120.4 75.24a57.276 57.276 0 0 1 -5.83 16.15 8.848 8.848 0 1 1 5.83-16.15z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53.005,
  cy: 86.472,
  r: 8.846
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81.186,
  cy: 92.472,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88.192,
  cy: 52.292,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83.179,
  cy: 37.877,
  r: 3
}));

var SvgMoonicon = function SvgMoonicon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    "data-name": "Layer 1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoonicon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moon.icon.8f42225a.svg";
export { ForwardRef as ReactComponent };